module.exports = __webpack_public_path__ + "img/ipay.e175e996.svg";